import DataCacheService from '@/shared/services/DataCacheService';
const validateBelgianVatNumber = (value) => {
    if (Number(value.slice(1, 2)) === 0)
        return false;
    const valueWithoutPrefix = value.length === 9 ? value : value.substring(2);
    const check = 97 - (Number(valueWithoutPrefix.slice(0, 8)) % 97);
    return check === Number(valueWithoutPrefix.slice(8, 10));
};
const validateVatNumber = (value) => {
    var _a;
    if (value === null || value === undefined || value === '')
        return true;
    const tenantConfiguration = (_a = DataCacheService.getDataCache()) === null || _a === void 0 ? void 0 : _a.tenantConfiguration;
    if (tenantConfiguration === 2)
        return true;
    const cleaned = value.replace(/[^0-9a-zA-Z]/g, '');
    if (cleaned.length <= 2)
        return false;
    if (cleaned.toLowerCase().startsWith('be')) {
        return validateBelgianVatNumber(cleaned);
    }
    return true;
};
export default validateVatNumber;
